import type { ButtonHTMLAttributes } from 'react';

import { cn } from '@/utils/cn';

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  isLoading?: boolean;
  size?: 'sm' | 'md' | 'lg' | 'icon';
};

export const iconButtonClassName =
  'tap-target inline-flex h-10 w-10 items-center justify-center rounded-full border border-slate-200 bg-white text-slate-600 shadow-sm transition hover:border-slate-300 hover:text-slate-800 dark:border-slate-700 dark:bg-slate-800/95 dark:text-slate-200 dark:hover:border-slate-600 dark:hover:bg-slate-700/90';

const sizeClassMap: Record<NonNullable<ButtonProps['size']>, string> = {
  sm: 'h-9 px-3 text-sm rounded-full',
  md: 'h-10 px-4 text-sm rounded-full',
  lg: 'h-11 px-5 text-base rounded-full',
  icon: 'h-10 w-10 rounded-full px-0'
};

export function Button({ className, isLoading = false, size = 'md', children, ...props }: ButtonProps) {
  return (
    <button
      className={cn(
        'tap-target inline-flex items-center justify-center gap-2 bg-brand-600 font-semibold text-white shadow-sm transition active:scale-[0.99] hover:bg-brand-700 disabled:cursor-not-allowed disabled:opacity-60',
        sizeClassMap[size],
        className
      )}
      disabled={isLoading || props.disabled}
      {...props}
    >
      {isLoading ? 'Please wait...' : children}
    </button>
  );
}
